import React from 'react';
import { StyledTableCell } from './TableCell.styles';
import { GridProps, LayoutProps, PaddingProps } from 'styled-system';

export type TableCellProps = {
  children: React.ReactNode;
  align?: 'left' | 'center' | 'right';
} & LayoutProps &
  PaddingProps &
  GridProps;

const TableCell = ({ children, align, ...rest }: TableCellProps) => {
  return (
    <StyledTableCell justifyContent={align} {...rest}>
      {children}
    </StyledTableCell>
  );
};
export default TableCell;
